<template>
<div v-if="team" v-bind:class="{'wait': deletionStarted }" class="panel-content">
    <confirmModal v-if="showConfirmModal" message="Vous êtes sûr de vouloir supprimer votre équipe ??" @confirm="deleteTeam" @closeMessage="closeConfirmModal"></confirmModal>
    <messageModal v-if="showDeleteMessage" message="votre équipe a été supprimée" @closeMessage="closeDeleteMessage"></messageModal>
    <div class="row columns">
        <div class="large-9 columns">
            <div class="row">
                <div class="large-3 columns">
                    <img class="team-icon-big" v-bind:src="getRosterIcon()" alt="">
                </div>
                <div  class="large-9 columns team-detail">
                    <div class="row">
                        <div class="team-name">{{team.name}}</div>
                    </div>
                    <div class="row">
                        <div  class="large-6 columns team-detail">
                            <div class="row columns team-data"><i class="fa fa-tag" aria-hidden="true"></i>  {{team.ref_roster.name}}</div>
                            <div class="row columns team-data"><i class="fa fa-tachometer" aria-hidden="true"></i> Team Value {{team.TV}}</div>
                            <div class="row columns team-data"><i class="fa fa-money" aria-hidden="true"></i> Trésor {{team.treasury}} 000 pO</div>
                            <div class="row columns team-data"><i class="fa fa-hand-o-right" aria-hidden="true"></i><strong>{{status}}</strong></div>
                        </div>
                        <div  class="large-6 columns team-detail">
                            <div class="row columns team-data"><i class="fa fa-user" aria-hidden="true"></i> coachés par {{team.user.username}}</div>
                            <div class="row columns team-data"><i class="fa fa-handshake-o" aria-hidden="true"></i> {{team.league.Club.name}}</div>
                            <div class="row columns team-data"><i class="fa fa-calendar" aria-hidden="true"></i> {{team.league.name}}</div>
                            <div class="row columns team-data"><i class="fa fa-address-book-o" aria-hidden="true"></i> {{team.ranking_group}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <teamHeaderActions :actions="actions" :team="team"></teamHeaderActions>
        </div>
        <div class="large-3 columns">
                <imageEditor v-if="team.icon_file_path"
                             class="team-image"
                             ref="imgEditor"
                             @ImageEditorClosed="update_team_icon"
                             :imageSrc="team.icon_file_path"></imageEditor>
                <imageEditor v-else
                             class="team-image"
                             ref="imgEditor"
                             @ImageEditorClosed="update_team_icon"
                             :imageSrc="'http://placehold.it/640x640'"></imageEditor>
        </div>
        <div class="row">
            <div class="large-9 large-centered note">
            </div>
        </div>
        <hr>
    </div>
</div>
<div v-else>
    <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import confirmModal from '../../common/confirm-modal.vue'
import messageModal from '../../common/message-modal.vue'
import { mapGetters } from 'vuex'
import team from '../../../api/team.api'
import teamHeaderActions from './team-header-actions.vue'
import imageEditor from '../../common/image-editor.vue'

export default {
  name: 'teamDetailHeader',
  components: {
    spinner,
    confirmModal,
    messageModal,
    teamHeaderActions,
    imageEditor
  },
  props: {
    'team': null,
    'actions': true
  },
  data () {
    return {
      showConfirmModal: false,
      showDeleteMessage: false,
      deletionStarted: false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    status: function () {
      if (this.team.status === 0) {
        return 'brouillon'
      } else if (this.team.status === 1) {
        return 'prête à jouer'
      } else if (this.team.status === 2) {
        return 'faire les montées de niveau'
      } else if (this.team.status === 3) {
        return 'faire les achats'
      } else if (this.team.status === 5) {
        return 'Saison terminée'
      }
    }
  },
  methods: {
    update_team_icon () {
      let datas = {}
      datas.icon_file_path = this.$refs.imgEditor.currentImageSrc
      console.log(datas)
      team.api.updateTeam(this.team.id, datas)
    },
    getRosterIcon () {
      return '/static/imgs/team-icons/' + this.team.ref_roster.name.replace(/\s+/, '') + '.png'
    },
    closeConfirmModal () {
      this.showConfirmModal = false
    },
    closeDeleteMessage () {
      this.showDeleteMessage = false
      this.$router.push({name: 'TeamList'})
    },
    deleteTeam () {
      this.showConfirmModal = false
      this.deletionStarted = true
      team.api.deleteTeam(this.team.id)
      .then(
        response => {
          this.showDeleteMessage = true
        },
        error => {
          console.log('Impossible to delete team ' + this.team.id)
          console.log(error)
        }
      )
    }
  },
  created () {
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.team-detail {
  text-align:left
}

.team-data {
  font-size: 0.8rem;
}

.small-icon {
    width: 25px;
    height: 25px;
}

.team-name {
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
    font-size:2rem;
}

.team-image {
    margin-right: 2rem;
}

.team-icon-big {
    margin-top: 1rem;
}

.match-stats {
    font-size: 0.9rem;
    font-weight: 300;
}

.single-stat {
    margin: 0.5rem;
}
.wait {
  cursor: wait;
}
</style>



// WEBPACK FOOTER //
// team-detail-header.vue?37240644